import api from '@/api/signup';
import { Store } from 'vuex';
import { AxiosRequestConfig } from 'axios';

const requestHandler = (token: string) => (config: AxiosRequestConfig) => {
  config.headers = {
    Token: token,
  };
  // console.log('requesting:', config.url, ' ', 'using token:', token);
  return config;
};

// TODO add IRootState
export default (store: Store<any>) => {
  let interceptorId = -1;
  store.subscribe(async (mutation) => {
    if (mutation.type !== 'updateToken') {
      return;
    }

    const token = mutation.payload;
    const handler = requestHandler(token);
    if (interceptorId !== -1) {
      api.interceptors.request.eject(interceptorId);
    }
    interceptorId = api.interceptors.request.use(handler, undefined);
  });
};
